import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@/global/components/ui/popover'
import { SmilePlusIcon } from 'lucide-react'
import { DynamicIcon, type IconName } from 'lucide-react/dynamic'
import dynamicIconImports from 'lucide-react/dynamicIconImports'
import { useMemo, useState } from 'react'
import IconButton from '../Button/IconButton'
import { Input } from '../ui/input'
import { Tooltip } from '../ui/tooltip'

const NOMES = Object.keys(dynamicIconImports) as IconName[]

interface IProps {
    onSelect: (nome: IconName) => void
}

export function IconPicker({ onSelect }: IProps) {
    const [busca, setBusca] = useState('')

    const resultados = useMemo(() => {
        const termo = busca.trim().toLowerCase()
        const base = termo ? NOMES.filter(nome => nome.includes(termo)) : NOMES

        return base.slice(0, 60)
    }, [busca])

    return (
        <Popover>
            <PopoverTrigger asChild>
                <IconButton>
                    <Tooltip title="Inserir ícone">
                        <SmilePlusIcon />
                    </Tooltip>
                </IconButton>
            </PopoverTrigger>
            <PopoverContent className="w-72">
                <Input
                    autoFocus
                    type="search"
                    variant="outlined"
                    size="small"
                    placeholder="Buscar ícone"
                    value={busca}
                    onChange={event => setBusca(event.target.value)}
                />
                <div className="mt-2 grid max-h-48 grid-cols-6 gap-1 overflow-y-auto">
                    {resultados.map(nome => (
                        <Tooltip title={nome} key={nome}>
                            <IconButton
                                key={nome}
                                className="rounded p-2 hover:bg-accent"
                                onClick={() => onSelect(nome)}
                            >
                                <DynamicIcon name={nome} />
                            </IconButton>
                        </Tooltip>
                    ))}
                </div>
            </PopoverContent>
        </Popover>
    )
}
